<template>
  <div>
    <h1>Hello</h1>
  </div>
</template>

<script>
export default {
    name:
    "DashboardV2",
}
</script>